module.exports = __webpack_public_path__ + "img/prioritas_sameday_cod.b4d957be.png";